import styled from 'styled-components';
import theme from 'theme/theme';

const InputContainer = styled.div`
	display: flex;
	align-items: center;
	border-radius: 5px;
	height: ${(props) => (props.textarea ? '100px' : '45px')};
	box-sizing: border-box;
	width: 100%;
`;

const StyledInput = styled.input`
	background-color: transparent;
	border: none;
	color: ${theme.primaryText};
	font-size: 16px;
	box-sizing: border-box;
	outline: none;
`;

const StyledTextArea = styled.textarea`
	resize: none;
	background-color: transparent;
	border: none;
	height: 100%;
	width: 100%;
	outline: none;
`;

const Label = styled.p`
	margin: 0;
	margin-bottom: 5px;
`;

export { InputContainer, StyledInput, StyledTextArea, Label };
